import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { EstateTopRightFunction } from '@/features/estates/components/estate-top-right-function';
import { EstateBreadcrumb } from '@/features/estates/components/estateBreadcrumb';
import { useTrackEstateView } from '@/features/posthog/hooks/use-estate-view';
import { getEstate, getEstateQueryOptions } from '@/features/estates-property/api/estate';
import {
  requireGeneralRead,
  withNotFoundOnNoAccess,
} from '@/features/permissions/route-permissions';

const Component = () => {
  const estateId = Route.useParams().estateId;
  useTrackEstateView(estateId);

  return (
    <DashboardLayout type="estate">
      <Outlet />
    </DashboardLayout>
  );
};

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout'
)({
  component: Component,
  // beforeLoad runs before child routes, so no tab requests data for an estate without access.
  // It runs on every navigation, so it reads the query cache and the loader stays the fresh source.
  beforeLoad: async ({ context, params }) => {
    const estate = await withNotFoundOnNoAccess(
      context.queryClient.ensureQueryData(getEstateQueryOptions(params.estateId))
    );

    requireGeneralRead(estate.metadata?.permissions);

    return { estate };
  },
  loader: async ({ params }) => {
    const estate = await withNotFoundOnNoAccess(getEstate(params.estateId));

    requireGeneralRead(estate.metadata?.permissions);

    return estate;
  },
  staticData: {
    breadcrumb: EstateBreadcrumb,
    topRightFunction: EstateTopRightFunction,
  },
});
